export const th = {
    LEFT: 'ซ้าย:ย้ายไปที่ก่อนหน้าวัน',
    RIGHT: 'ขวา:ย้ายไปในวันถัดมา ',
    DOWN: 'ลง:ย้ายไปต่อแถวด้วย ',
    UP: 'ขึ้นมา:ย้ายไปที่ก่อนหน้านั่น ',
    PGUP: 'Pgupqshortcut:ย้ายไปยังเดือนก่อน. ',
    PGDOWN: 'Pgdownqshortcut:ย้ายไปยังเดือนหน้านี้ ',
    HOME: 'กลับบ้าน:ย้ายไปเมื่อปีก่อน ',
    END: 'สิ้นสุด:ย้ายไปยังปีหน้า ',
    ESC: 'Esc/วันนี้/ปิด:ปิดปฏิทิน ',
    TITLE: 'แป้นพิมพ์คำสั่ง'
};
